export enum AppStatus {
  Idle = "Idle",
  Loading = "Loading",
  NoCompanyData = "NoCompanyData",
  Failed = "Failed",
  Success = "Success",
}
